/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, createSearchParams } from 'react-router-dom';
import { Box, Center, Loader, Stack, Image } from '@mantine/core';
import Pos from '../../image/pos.png';

const Home = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const passIdData = searchParams.get('passId');

  const findMyCarStation = () => {
    navigate('/findmycarstation/findmycar');
  };

  const [paymentData, setPaymentData] = useState([]);

  // const queryParam = `?long=77.669907&lat=12.900836`;
  useEffect(() => {
    fetch('http://192.168.0.186:9001/payments', {
      method: 'POST',
      headers: {
        android_id: 'test',
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        pass_id: '1664174299484',
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res?.success === true) {
          navigate({
            pathname: '/pospaymentstatus',
            search: createSearchParams({
              passId: passIdData,
            }).toString(),
          });
        }
      });

    setTimeout(() => {
      navigate({
        pathname: '/pospaymentstatus',
        search: createSearchParams({
          passId: passIdData,
        }).toString(),
      });
    }, 5000);
  }, []);

  return (
    <Box>
      <Center p="xl">
        <Stack>
          <Center>
            <Image src={Pos} px="md" sx={{ width: '50%' }} />
          </Center>
          <Center>
            <Loader
              size="xl"
              variant="bars"
              color="teal"
              sx={{ width: '100px', height: '100px' }}
            />
          </Center>
        </Stack>
      </Center>
    </Box>
  );
};

export default Home;
